<template>
  <div>
    <Header >
      <v-btn small depressed @click="gotoprint()" color=btns class="ml-4"><span>Foglio ripasso</span></v-btn>
      <v-btn v-if="isLoggedIn" color="cfbg" small depressed @click="logout()" clolor=blue class="ml-4"><span>Logout</span></v-btn>
    </Header>
    <login-popup v-if="showLoginPanel" @close="closepopup" />
    <edit-popup v-if="openEditPopup" @close="closepopup" :editOptions="editOptions"/>
    <v-container>
      <v-row>
        <v-col xs=4 sm=4 md=4>
          <KanjiSheet  v-if="kanjiData" :kanjiData="kanjiData" :styleData="styleData"/>
        </v-col>
        <v-col xs=8 sm="8" md="8">
          <table v-if="kanjiData" class="tb" aria-label="Traduzione">
            <tr v-if="ita">
              <th class="cfbg" scope="row">
                <button v-if="isLoggedIn" class="edit-icon-btn" @click="edit('ita',kanjiData.literal)" aria-label="Modifica traduzione italiana">
                  <v-icon dark aria-hidden="true">edit</v-icon>
                </button>Italiano
              </th>
              <td>{{ ita }}</td>
            </tr>
            <tr v-if="!ita">
              <th class="cfbg" scope="row">
                <button v-if="isLoggedIn" class="edit-icon-btn" @click="edit('eng',kanjiData.literal)" aria-label="Modifica traduzione">
                  <v-icon dark aria-hidden="true">edit</v-icon>
                </button>Trad. Appr.
              </th>
              <td>{{ eng }}</td>
            </tr>
          </table>
<!--
          <div id="kanji-real" v-if="kanjiData">
              <span class='elem mincho'>{{kanjiData.literal}}</span>
              <span class='elem gothic'>{{kanjiData.literal}}</span> 
          </div>-->

          <table v-if="kanjiData" class="tb" aria-label="Dettagli kanji">
            <tr>
              <th class="cfbg" scope="row">画数</th>
              <td v-if="kanjiData">{{ kanjiData.misc.stroke_count  }}</td>
              <th class="cfbg" scope="row">JLPT</th><td>{{ kanjiData.misc.jlpt}}</td>
            </tr>
            <tr>
              <th class="cfbg" scope="row">オン読み</th>
              <td colspan=3>{{ reads("on") }}</td>
            </tr>
            <tr>
              <th class="cfbg" scope="row">くん読み</th>
              <td colspan=3>{{ reads("kun") }}</td>
            </tr>
            <tr>
              <th class="cfbg" scope="row">部首</th>
              <td>{{  kanjiData.radical.rad_string.radical.join(" ") }} ({{kanjiData.radical.rad_string.name.join(", ")}})</td>
              <th class="cfbg" scope="row">ぶんかい</th><td>{{kanjiData.krad[0].items.join(" ")}}</td>
            </tr>
            <tr v-if="kanjiData.composition">
              <th class="cfbg" scope="row">Kanji simili</th>
              <td class="composition" colspan=3 v-html="setComp()"></td>
            </tr>
          </table>
          <v-btn small class=btns dark @click="gotoprint()">Stampa</v-btn>
        
        </v-col>
      </v-row>
      <WikimediaExamples v-if="kanjiData" :kanjiData="kanjiData" />
      <TextbookExamples v-if="kanjiData" :kanjiData="kanjiData"/>
      <TermExamples v-if="kanjiData" :kanjiData="kanjiData"/>
    </v-container>
  <Footer></Footer>
  </div>
</template>
<script>
import Axios from 'axios';

import ApiAuth from '@/services/ApiAuth.js';
import {EkDetailsMixin} from "@/components/EkDetailsMixin.js";
import WikimediaExamples from "@/components/WikimediaExamples.vue";
import TextbookExamples from "@/components/TextbookExamples.vue";
import LoginPopup from '@/components/LoginPopup.vue';
import EditPopup from '@/components/EditPopup.vue';
export default {
  mixins:[EkDetailsMixin],
  data() {
    return {
      dialog:true,
      showLoginPanel:false,
      openEditPopup:false,
      editOptions:[]
    }
  },
  computed : {
    isLoggedIn() {
      console.log("isloggedin",this.$store.getters.feLoggedId && !this.showLoginPanel );
      return this.$store.getters.feLoggedId && !this.showLoginPanel;
    }
  },
  methods:{
    gotoprint() {
      if (this.kanjiData) {
      return this.$router.push("/print/"+this.kanjiData.literal)
      }
    },
    setComp() {
      if (this.kanjiData) {
        return this.kanjiData.composition.elem.map(e=> {
          let targetLink = "<a href='/kanji/"+e.char+"'>"+e.char+"</a>";
          console.log(targetLink);
          return targetLink;
        }).join(" ")

      }
    },
    closepopup(values) {
      this.showLoginPanel=false;
      this.openEditPopup=false;

      if (typeof values.updateValue != "undefined") {
        console.log("-----",this.kanjiData);
        if (this.kanjiData.italian.length == 0) {
          this.kanjiData.italian = [{ita:values.updateValue}];
        } else {
          this.kanjiData.italian[0].ita = values.updateValue;
        }
      }
    },
    logout() {
      this.$store.commit("setFeLogout");
      this.showLoginPanel=true;
    },
    edit(target,literal) {
      switch (target) {
        case "ita":
          //Axios.post("/api/edukanji/edit/get/ita",{literal:literal}).then((result)=>{});
          ApiAuth().post("api/edukanji/edit/get/ita",{literal:literal})
          .then((result) => {
            if(result) {
                  //result.data.result[0]
              this.openEditPopup = true;
              this.editOptions = {values: result.data.result[0].ita,literal:literal};
              
            }
          }).catch((error)=> {

          }) 
          break;
        default:
              this.openEditPopup = true;
              this.editOptions = {values: "",literal:literal,isNewTranslation:true};
        break;
      }
    }
  },
  components: {
    WikimediaExamples,
    TextbookExamples,
    LoginPopup,
    EditPopup
  },
  watch: {
    kanjiData(val) {

    },
    isFrontendAdmin(val) {
      console.log("qqq",val);
    }
  }
  ,mounted() {
      console.log("getters",this.$store.getters.feLoggedId); 
    
      if ( this.$route.meta.isFrontendAdmin == 1) {
        //
        
        if (this.$store.getters.feLoggedId == "" || this.$store.getters.feLoggedId == undefined) {
          //
          this.showLoginPanel = true;
        } 
        
      }
  }
};
</script>

<style scoped>
#kanji-real {
  font-size:40px;
}
#kanji-real .elem {
  padding:8px;
  border:1px solid #eeeeee;
  border-radius:8px;
  margin-right:8px;
}
.mincho {
  font-family:'Sawarabi Mincho'
}
.gothic {
  font-family:'Sawarabi Gothic'
}

.tb {
  border-collapse: separate;
  border-spacing: 2px;
  width:100%;

}
.tb td,.tb th {
  border:1px solid #eeeeee;
  padding:8px;
}
.tb th {
  width:100px;
  color:white;
}
#trans {
  font-size:20px;
}
.composition {
  font-size:larger;
}
.edit-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 4px 0 0;
  vertical-align: middle;
}

</style>
